import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';

import { ContactsPopup, ICallContact } from '../../../packages/Call';
import { useCall } from '../../hooks';
import { useOfferContext } from '../OfferContext';

export interface IOfferContactsPopupContainerProps {
  onClose(): void;
}

export function ContactsPopupContainer({ onClose }: IOfferContactsPopupContainerProps) {
  const { author } = useOfferContext();
  const [isPhoneVisible, setPhoneVisibility] = React.useState(false);
  const [comagicPhone, setComagicPhone] = React.useState<string | null>(null);

  const { loadComagicPhone, produceCall, phone: authorPhone, isLeadFactory } = useCall();

  const phone = comagicPhone || authorPhone;

  React.useEffect(() => {
    async function load() {
      setPhoneVisibility(false);
      const comagicPhone = await loadComagicPhone();

      setComagicPhone(comagicPhone);
    }

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phone]);

  const onPhoneClick = React.useCallback(() => {
    if (!phone) {
      return;
    }

    if (!isPhoneVisible) {
      setPhoneVisibility(true);
    } else {
      produceCall(phone);
    }
  }, [isPhoneVisible, phone, produceCall]);

  const contact: ICallContact = {
    avatar: author.avatar,
    displayName: author.name,
    description: isLeadFactory ? 'Консультант' : author.fromDeveloper,
  };

  if (!phone) {
    return null;
  }

  return (
    <ModalWindow
      open
      fixed
      portal
      size="M"
      onClose={onClose}
      content={
        <ContactsPopup isPhoneVisible={isPhoneVisible} phone={phone} contact={contact} onPhoneClick={onPhoneClick} />
      }
    />
  );
}
